export const VERSION = "1.4.3"
export const UPDATE_TIME = "2022-10-08"
export const VERSION_SIZE = "17.38MB"
